import React from 'react';
import { Link } from 'react-router-dom';
import BaseGridToolbar from '../shared/toolbar/BaseGridToolbar';
import ToolbarButton from '../shared/toolbar/ToolbarButton';
import EditModeToggle from '../shared/table/components/EditModeToggle';
import { useMediaQuery } from '../../hooks/useMediaQuery';

const AddCoinButton = ({ isMobile }) => (
  <Link to="/coins/add">
    <ToolbarButton
      variant="contained"
      startIcon={
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
        </svg>
      }
    >
      {!isMobile && 'Add Coin'}
    </ToolbarButton>
  </Link>
);

const CoinListToolbar = ({ columns, data, selectedItems, ...props }) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  return (
    <BaseGridToolbar
      title={selectedItems?.size > 0 ? `${selectedItems.size} Selected` : "Inventory"}
      columns={columns}
      data={data}
      actionButton={
        <div className="flex items-center gap-2">
          {!isMobile && <EditModeToggle />}
          <AddCoinButton isMobile={isMobile} />
        </div>
      }
      {...props}
    />
  );
};

export default React.memo(CoinListToolbar);
